/**
 * The data regions. One list, with no imports, so a server schema, the auth service and the admin
 * panel can all read it without pulling in a validator. `regionSchema` in `@typedoc/contracts` is
 * built from it.
 */
export const REGIONS = ["au", "us"] as const;
export type Region = (typeof REGIONS)[number];
